import { useCallback, useState } from 'react';
import { candidateService } from '../../../api';
import { FileUploadState } from '../../../models/File';
import { RetrieveS3URLResponse } from '../../../api/document/files/api-services/model';

export const useAuditDownloadAction = (
  initialDate: string,
  endDate: string,
  accountType?: string,
  roles?: string,
  action?: string
) => {
  const [fileDownloadStatus, setFileDownloadStatus] = useState<FileUploadState>(
    FileUploadState.IDLE
  );
  const [dialogState, setDialogState] = useState<boolean>(false);

  const [fileUUID, setFileUUID] = useState('');

  const { mutate: auditDownloadMutate } = candidateService.audit.opadmin.useAuditDownload(
    (response) => {
      setFileUUID(response.uuid);
    },
    (error) => null
  );

  /** to define bulk download
   * */
  const onHandleExport = useCallback(() => {
    setDialogState(true);
    auditDownloadMutate({
      startDate: initialDate,
      endDate,
      accountType,
      roles,
      action,
    });
  }, [auditDownloadMutate, initialDate, endDate, accountType, roles, action]);

  /** handle download action
   * */
  const downloadCSV = (downloadResponse: RetrieveS3URLResponse) => {
    setDialogState(true);
    if (downloadResponse.fileStatus === FileUploadState.SUCCESS) {
      setFileUUID('');
      setDialogState(false);
    }
    setFileDownloadStatus(downloadResponse.fileStatus as FileUploadState);
  };

  /** handle dialog close
   * */
  const onDialogClose = () => {
    setDialogState(false);
    setFileUUID('');
  };

  return {
    dialogState,
    fileDownloadStatus,
    fileUUID,
    onHandleExport,
    downloadCSV,
    onDialogClose,
  };
};
